import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Image, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import Auburn from '../../../../../../images/AuburnLogo.png';
export const PageOne = memo(() => {
    const styles = StyleSheet.create({
        container: {
            padding: '20px 30px',
        },
        headerContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            marginBottom: 25,
        },
        image: {
            width: 75,
            height: 75,
        },
        title: {
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontWeight: 700,
            fontSize: 18,
            textAlign: 'center',
        },
        subtitle: {
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontWeight: 700,
            fontSize: 16,
            textAlign: 'center',
        },
        titleContainer: {
            flexDirection: 'column',
            padding: '5px 0px 5px 15px',
            justifyContent: 'center',
            textAlign: 'center',
            alignContent: 'center',
        },
        bold: {
            fontWeight: 700,
            fontSize: 12,
            marginBottom: 5,
            fontFamily: 'Roboto',
            fontStyle: 'bold',
        },
        p: {
            fontSize: 12,
            fontFamily: 'Roboto',
        },
        pMd: {
            fontSize: 12.5,
            fontFamily: 'Roboto',
        },
        upper: {
            fontSize: 12,
            fontFamily: 'Roboto',
            textTransform: 'uppercase',
        },
        row: {
            flexDirection: 'row',
            margin: '10px 0px 10px',
            justifyContent: 'space-evenly',
            alignContent: 'center',
        },
        col: {
            flexDirection: 'column',
            margin: '10px 0px 10px',
            justifyContent: 'center',
            textAlign: 'center',
            alignContent: 'center',
        },
    });
    return (_jsxs(Page, { size: 'A4', wrap: false, children: [_jsxs(View, { style: styles.container, children: [_jsxs(View, { style: styles.headerContainer, children: [_jsx(Image, { style: styles.image, src: Auburn }), _jsxs(View, { style: styles.titleContainer, children: [_jsx(Text, { style: styles.title, children: "New Account" }), _jsx(Text, { style: styles.subtitle, children: "Information & Application" })] })] }), _jsx(Text, { style: styles.bold, children: "The Auburn Advantage" }), _jsx(Text, { style: styles.p, children: "Customer service is our priority at Auburn. We are invested in understanding your goals, your challenges, and the ways in which we can provide concrete solutions to your needs. Our experienced and reliable Account Managers are readily available to support you via your preferred method of communication whether text, email, or phone. We commit to continually building upon what we can offer you and your pharmacy, while providing transparency, flexibility, and standard setting customer service." }), _jsx(Text, { style: { textAlign: 'center', fontStyle: 'bold', fontFamily: 'Roboto', fontSize: 12, margin: '0px auto', }, children: "Enjoy The Difference!" }), _jsxs(View, { style: styles.col, children: [_jsx(Text, { style: styles.pMd, children: "Call 1-800-222-5609" }), _jsx(Text, { style: styles.pMd, children: "Visit us online at www.AuburnGenerics.com for 24 Hour Online Ordering" }), _jsx(Text, { style: styles.pMd, children: " Email: customerservice@auburnpharm.com" })] }), _jsxs(View, { style: styles.row, children: [_jsxs(View, { style: styles.col, children: [_jsx(Text, { style: styles.bold, children: "Troy, Michigan Main Office" }), _jsx(Text, { style: styles.upper, children: "HOURS OF OPERATION" }), _jsx(Text, { style: styles.p, children: "Monday- Friday (8:30am-6:30pm EST)" }), _jsx(Text, { style: styles.p, children: "Fax #: 248-526-3750" }), _jsx(View, { style: { height: 20, } }), _jsx(Text, { style: styles.p, children: "Corporate Office Address:" }), _jsx(Text, { style: styles.p, children: "1744 Rochester Industrial Drive" }), _jsx(Text, { style: styles.p, children: "Rochester Hills, MI 48309" })] }), _jsxs(View, { style: styles.col, children: [_jsx(Text, { style: styles.bold, children: "Salt Lake City, Utah Warehouse" }), _jsx(Text, { style: styles.upper, children: "HOURS OF OPERATION" }), _jsx(Text, { style: styles.p, children: "Monday- Friday (8:30am-6:00pm MTN)" }), _jsx(Text, { style: styles.p, children: "Fax #: 801-886-1526" }), _jsx(View, { style: { height: 20, } }), _jsx(Text, { style: styles.p, children: "Remit Address \u2013 Payments:" }), _jsx(Text, { style: styles.p, children: "P.O. Box 72216" }), _jsx(Text, { style: styles.p, children: "Cleveland, OH 44192-2216" })] })] }), _jsx(Text, { style: { ...styles.bold, textAlign: 'center', margin: '5px auto 10px', }, children: "Return Policy" }), _jsx(Text, { style: styles.p, children: "All returns must receive prior Auburn authorization. For full credit the return must be made within 180 days from purchase date. The price paid or current price, whichever is lower, minus a 25% restocking fee, will be credited after 180 days. Only products and lot numbers purchased from Auburn Pharmaceutical may be returned for credit. All returns must be made directly to Auburn. Third party returns will not be accepted for credit. Contact your Account Manager for a return authorization." }), _jsx(View, { style: { height: 10, } }), _jsx(Text, { style: styles.p, children: "Only unopened products purchased from Auburn eligible for return credit. Items marked as *NR* are not returnable. Expired product is not returnable. No credit will be issued for opened or partial bottles unless product is recalled. Please remove all price stickers and other markings from products. Defaced, damaged or soiled products are subject to a 25% restocking charge. Return requests over $1,000.00 are subject to special review and may be subject to handling fees." })] }), _jsx(Text, { style: { ...styles.p, position: 'absolute', bottom: 30, left: 30, }, children: "Rev 06/23/21" })] }));
});
